import React from "react";
import { Flex, Modal, Typography } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { confirmFooter } from "@/components/modals/confirmFooter";

const { Text } = Typography;

/**
 * El cuerpo del panel con scroll y el pie fijo abajo, como el de Atributos (xcons-docs#636). Es un
 * componente y no un `div` porque `LateralModal` le pasa `closeModal` a su hijo, y un `div` no lo
 * acepta.
 */
export const CuerpoConPie: React.FC<{
  children: React.ReactNode;
  pie: React.ReactNode;
  closeModal?: () => void;
}> = ({ children, pie }) => (
  <Flex vertical style={{ flex: 1, overflow: "hidden" }}>
    <div style={{ flex: 1, overflowY: "auto", padding: "16px 24px" }}>
      {children}
    </div>
    <Flex
      justify="space-between"
      gap={8}
      style={{
        flexShrink: 0,
        padding: "12px 24px",
        borderTop: "1px solid #f0f0f0",
        backgroundColor: "#fff",
      }}
    >
      {pie}
    </Flex>
  </Flex>
);

/** El título de una parte del panel, con lo que haga falta a su derecha (ej. "En uso"). */
export const Subtitulo: React.FC<{
  children: React.ReactNode;
  extra?: React.ReactNode;
}> = ({ children, extra }) => (
  <Flex align="center" gap={8} style={{ margin: "8px 0 12px" }}>
    <Text strong>{children}</Text>
    {extra}
  </Flex>
);

/** Como las confirmaciones del Catálogo: "Atrás" a la izquierda y "Sí, eliminar" a la derecha. */
export const confirmarBorrado = (
  title: string,
  onOk: () => Promise<void>,
  content?: React.ReactNode,
) =>
  Modal.confirm({
    title,
    content,
    okText: "Sí, eliminar",
    cancelText: "Atrás",
    cancelButtonProps: { icon: <LeftOutlined /> },
    footer: confirmFooter,
    onOk,
  });

/**
 * El encabezado de las tablas: fino como sus filas, con el texto a la izquierda y centrado en
 * vertical (xcons-docs#636).
 */
export const ENCABEZADO_DE_TABLA = {
  header: {
    cell: (props: React.ThHTMLAttributes<HTMLTableCellElement>) => (
      <th
        {...props}
        style={{
          ...props.style,
          textAlign: "left",
          verticalAlign: "middle",
        }}
      />
    ),
  },
};

/**
 * El paginador de las tablas: 10 por página, fijo. Del tamaño normal, como en Catálogo, porque el
 * `size="small"` de la tabla también lo achica (xcons-docs#636).
 */
export const PAGINADOR = {
  pageSize: 10,
  showSizeChanger: false,
  size: "default" as const,
};
